export default "__VITE_ASSET__BnLnisSD__"